import { useQuery } from '@tanstack/react-query'
import { getAllCompanies } from '../../../api/companies/getAllCompanies'

export const useGetAllCompanies = () => {
  return useQuery({
    queryKey: ['allCompanies'],
    queryFn: getAllCompanies,
    staleTime: 1000 * 60 * 5, // datos considerados frescos por 5 minutos
    gcTime: 1000 * 60 * 30, // datos permanecen en caché por 30 minutos
    refetchOnMount: true, // revalidar al montar el componente
    refetchOnWindowFocus: false, // no revalidar al enfocar la ventana
  })
}